//create FEEDBACK
export const CREATE_FEEDBACK_REQUEST = "CREATE_FEEDBACK_REQUEST";
export const CREATE_FEEDBACK_ERROR = "CREATE_FEEDBACK_ERROR";
export const CREATE_FEEDBACK_SUCCESS = "CREATE_FEEDBACK_SUCCESS";

//Get  all FEEDBACK QUESTION
export const GET_ALL_FEEDBACK_QUESTION_REQ = "GET_ALL_FEEDBACK_QUESTION_REQ";
export const GET_ALL_FEEDBACK_QUESTION_ERR = "GET_ALL_FEEDBACK_QUESTION_ERR";
export const GET_ALL_FEEDBACK_QUESTION_SUCC = "GET_ALL_FEEDBACK_QUESTION_SUCC";